/**
 * Selector
 * --------
 * Enum-like map of CSS selectors. Use with DOM.get(Selector.something).
 * Keep ALL strings here so they’re not scattered in your codebase.
 */
export const Selector = Object.freeze({
    // canvases / inputs
    canvasMain: '#viewimage',
    canvasDraw: '#viewimage_draw',
    canvasOriginal: '#viewimage_original',
    canvasDiv: '#viewimageDiv',

    // project infos
    countryIDInput: '#country_id',
    nameInput: '#name',
    firstnameInput: '#firstname',
    lastnameInput: '#lastname',
    addressInput: '#address',
    cityInput: '#city',
    stateInput: '#state',
    npaInput: '#npa',
    notesInput: '#notes',

    // company infos
    brand: '#brand',

    // image preview
    preview: '#preview',
    colorchartrow: '#colorchartrow',

    // prepaint project
    containerPrepaintedProject: '#container-prepainted-projects',

    // sliders (values)
    sliderOpacity: '#sliderOpacity',
    sliderWheel: '#sliderWheel',
    sliderRotate: '#sliderRotate',
    sliderScale: '#sliderScale',
    sliderBrush: '#brush-slider',

    // alt ids used in PaintingListener
    sliderWheelAlt: '#slider-wheel',
    brushSizeSlider: '#brush-size-slider',

    // tool buttons
    btnBrush: '#btnbrush',
    btnEraser: '#btneraser',
    btnMagic: '#btnmagic',
    btnHand: '#btnhand',
    btnDrawLine: '#btndrawline',
    btnDrawPolyMinus: '#btndrawpolyminus',
    btnDrawPolyPlus: '#btndrawpolyplus',
    btnRotate: '#btnrotate',

    // actions / export
    btnUndo: '#btnUndo',
    btnRedo: '#btnRedo',
    btnPDF: '#btnpdf',
    btnExport: '#btnexport',
    btnNewProject: '#btnnewproject',
    btnJpeg: '#btndownloadjpeg',
    btnAchat: '#btnachat',

    // uploader
    uploaderForm: '#file-upload-form',
    uploaderInput: '#file-upload',
    uploaderDrop: '#file-drag',
    uploaderImage: '#file-image',
    uploaderStart: '#start',
    uploaderResponse: '#response',
    uploaderNotImage: '#notimage',
    uploaderMessages: '#messages',
    uploaderProgress: '#file-progress',

    // pickers
    selectCc: '#selectcc',
    selectTe: '#selectte',
    scrollerEffects: '#scroller-effects', // todo inverser avec colorchartselectors

    // scroller
    textureswatchselectors: '#textureswatchselectors',
    colorchartselectors: '#colorchartselectors',

    // slider panels (visible/hidden groups)
    sliderLuminosityPanel: '#slider-luminosity',
    sliderRotatePanel: '#slider-rotate',
    sliderScalePanel: '#slider-scale',

    // collections
    deletedDropcolorButtons: '.deletedropcolor',

    // overlay
    loadingOverlay: '#overlay-loading-project',

    // settings controls
    settingsControls: '.viz-settings-controls',
    settingsToggle: '.viz-settings-toggle',
    settingsBody: '.viz-settings-body',

    // prepaint modal
    prepaintColorSampleModal: '#prepaintColorSampleModal',
    prepaintColorSampleForm: '#prepaintColorSampleForm',
    prepaintPreviewImg: '#prepaintPreviewImg',
    prepaintOpenBtn: '#btnOpenPrepaint',

    // ------------------------------
    // server update elements
    // ------------------------------

    // swatch
    colorchart: '#colorchart',

    // ------------------------------
    // nippon painting view
    // ------------------------------

    // modals
    modalVerify: '#userLoggedButEmailNotVerifiedModal',
    modalProfileCompletion: '#profileCompletionModal',
    modalLogin: '#loginModal',
    modalRegister: '#registerModal',
    modalForgotPassword: '#forgotPasswordModal',

    // auth / login
    loginForm: '#loginForm',
    recaptchaTokenLogin: '#recaptchaTokenLogin',
    recaptchaActionLogin: '#recaptchaActionLogin',

    // auth / register
    registerForm: '#registerForm',
    recaptchaTokenRegister: '#recaptchaTokenRegister',
    recaptchaActionRegister: '#recaptchaActionRegister',

    // auth / forgot password
    forgotPasswordForm: '#forgotPasswordForm',
    recaptchaTokenForgotPassword: '#recaptchaTokenForgotPassword',
    recaptchaActionForgotPassword: '#recaptchaActionForgotPassword',
})
window.Selector = Selector
